import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  amscompanyAccessPointList: [],
  amscompanyAccessGroupList: [],
  amssynccompanyAccessGroupList: [],
  amsVendorSyncAccessUsersList: [],
  privacyMode: false,
  dashboard: '',
  units: '',
  accessgroups: '',
  accesspoints: '',
};

const amsSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    amscompanyAccessPointAction: (state, action) => {
      state.amscompanyAccessPointList = [
        ...state.amscompanyAccessPointList,
        ...action.payload.amscompanyAccessPointList,
      ];
    },
    amscompanyAccessGroupAction: (state, action) => {
      state.amscompanyAccessGroupList = [
        ...state.amscompanyAccessGroupList,
        ...action.payload.amscompanyAccessGroupList,
      ];
    },
    amssynccompanyAccessGroupAction: (state, action) => {
      state.amssynccompanyAccessGroupList = action.payload.amssynccompanyAccessGroupList;
    },
    amsVendorSyncAccessUsersAction: (state, action) => {
      state.amsVendorSyncAccessUsersList = action.payload.amsVendorSyncAccessUsersList;
    },
    clientSettingsAction: (state, action) => {
      state.privacyMode = action.payload.privacyMode;
      state.dashboard = action.payload.dashboard;
      state.units = action.payload.units;
      state.accessgroups = action.payload.accessgroups;
      state.accesspoints = action.payload.accesspoints;
    },
    resetStateAction: () => initialState,
  },
});

export const { amscompanyAccessPointAction, amscompanyAccessGroupAction,
   amssynccompanyAccessGroupAction, amsVendorSyncAccessUsersAction,
    clientSettingsAction, resetStateAction} =
  amsSlice.actions;

export default amsSlice.reducer;
